<script>
  /** @type {{vertical: any, animation?: string}} */
  let { vertical, animation = 'bounce' } = $props();
</script>

<div class="simple-loading-ellipses {animation}" class:vertical>
  <div class="ellipse"></div>
  <div class="ellipse"></div>
  <div class="ellipse"></div>
</div>

<style lang="scss">
  .simple-loading-ellipses {
    display: flex;
    justify-content: center;
    padding: 0 0.5rem;
  }

  .vertical {
    flex-wrap: wrap;
    width: fit-content;
    padding-bottom: 3rem;
    overflow: hidden;

    .ellipse {
      flex-basis: 100%;
      margin: 1rem 0.3rem 0;
    }

    &.bubble .ellipse {
      transform: translateY(0) scale(0);
      animation: 1.5s bubble-vertical infinite linear;
    }
  }

  .bounce .ellipse {
    animation: 0.7s bounce infinite alternate;

    &:nth-child(2) {
      animation-delay: 0.25s;
    }

    &:nth-child(3) {
      animation-delay: 0.5s;
    }
  }

  .bubble .ellipse {
    transform: scale(0);
    animation: 1.5s bubble infinite linear;

    &:first-child {
      animation-delay: 0;
    }

    &:nth-child(2) {
      animation-delay: 0.25s;
    }

    &:nth-child(3) {
      animation-delay: 0.5s;
    }
  }

  .ellipse {
    min-width: 1rem;
    min-height: 1rem;
    margin: 2rem 0.3rem 0;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(66, 104, 52, 0.3);
    opacity: 1;
  }

  @keyframes bounce {
    to {
      opacity: 0.8;
      transform: translate3d(0, -1rem, 0);
    }
  }

  @keyframes bubble {
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }

  @keyframes bubble-vertical {
    50% {
      transform: translateY(1rem) scale(1);
    }
    100% {
      transform: translateY(2rem) scale(0);
    }
  }
</style>
